import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { View, Text } from 'react-native';
import { StyledModal } from '@constants/Themed';
import { Button, Input, XStack, YStack, Label } from 'tamagui';
import { useTranslation } from 'react-i18next';

interface FilterModalProps {
  onApplyFilters: (filters: any) => void;
  currentFilters?: any;
}

const FilterModal = forwardRef(({ onApplyFilters, currentFilters }, ref) => {
  const { t } = useTranslation();
  const modalRef = useRef(null);
  
  const [minSize, setMinSize] = useState(currentFilters?.minSize || '');
  const [maxSize, setMaxSize] = useState(currentFilters?.maxSize || '');
  const [location, setLocation] = useState(currentFilters?.location || '');

  useImperativeHandle(ref, () => ({
    openModal: () => {
        setMinSize(currentFilters?.minSize || '');
        setMaxSize(currentFilters?.maxSize || '');
        setLocation(currentFilters?.location || '');
        modalRef.current?.openModal();
    },
    closeModal: () => modalRef.current?.closeModal(),
  }));

  const handleApply = () => {
    onApplyFilters({
      minSize,
      maxSize,
      location
    });
    modalRef.current?.closeModal();
  };

  const handleClear = () => {
    setMinSize('');
    setMaxSize('');
    setLocation('');
    onApplyFilters({});
    modalRef.current?.closeModal();
  };

  return (
    <StyledModal
      ref={modalRef}
      title={t("Filter Data")}
      caption={t("Refine your search results")}
      extraChildren={(
        <XStack gap={10}>
             <Button
            onPress={handleClear}
            variant="outlined"
            backgroundColor="transparent"
            borderColor="$grey8"
            color="$grey12"
            size="$3"
          >
            <Text>{t("Clear")}</Text>
          </Button>
          <Button
            onPress={handleApply}
            backgroundColor="#3b82f6"
            color="white"
            size="$3"
          >
            <Text style={{color: 'white'}}>{t("Apply")}</Text>
          </Button>
        </XStack>
      )}
    >
      <YStack padding={20} gap={20}>
        <YStack gap={10}>
          <Label>Dataset Size (Items)</Label>
          <XStack gap={10}>
            <Input 
              flex={1} 
              placeholder="Min" 
              keyboardType="numeric"
              value={minSize}
              onChangeText={setMinSize}
            />
            <Input 
              flex={1} 
              placeholder="Max" 
              keyboardType="numeric"
              value={maxSize}
              onChangeText={setMaxSize}
            />
          </XStack>
        </YStack>

        <YStack gap={10}>
          <Label>Location</Label>
          <Input 
            placeholder="e.g. London, UK" 
            value={location}
            onChangeText={setLocation}
          />
        </YStack>
      </YStack>
    </StyledModal>
  );
});

export default FilterModal;

